import { createAction, props } from '@ngrx/store';
import { ILoaderActionPayload } from '../models/loader.model';
import {
  EmailEventRuleControllerCreate$Params,
  EmailEventRuleControllerDelete$Params,
  EmailEventRuleControllerFind$Params,
  EmailEventRuleControllerFindOne$Params,
  EmailEventRuleControllerUpdate$Params,
} from '../../../api/functions';
import { EmailEventRuleItem, EmailEventRuleListResponse } from '../../../api/models';

export const emailEventRuleActions = {
  // find list
  find: createAction('email-event-rule/find', props<EmailEventRuleControllerFind$Params>()),
  findDone: createAction(
    'email-event-rule/find/done',
    props<{
      state: ILoaderActionPayload;
      data?: EmailEventRuleListResponse;
      request?: EmailEventRuleControllerFind$Params;
    }>(),
  ),
  findSetState: createAction('email-event-rule/find/state', props<{ state: ILoaderActionPayload }>()),

  // find one
  findOne: createAction('email-event-rule/find-one', props<EmailEventRuleControllerFindOne$Params>()),
  findOneDone: createAction(
    'email-event-rule/find-one/done',
    props<{ state: ILoaderActionPayload; data?: EmailEventRuleItem }>(),
  ),
  findOneSetState: createAction('email-event-rule/find-one/state', props<{ state: ILoaderActionPayload }>()),

  // create
  create: createAction('email-event-rule/create', props<EmailEventRuleControllerCreate$Params>()),
  createDone: createAction(
    'email-event-rule/create/done',
    props<{
      state: ILoaderActionPayload;
      data?: EmailEventRuleItem;
      request?: EmailEventRuleControllerCreate$Params;
    }>(),
  ),
  createSetState: createAction('email-event-rule/create/state', props<{ state: ILoaderActionPayload }>()),

  // update
  update: createAction('email-event-rule/update', props<EmailEventRuleControllerUpdate$Params>()),
  updateDone: createAction(
    'email-event-rule/update/done',
    props<{
      state: ILoaderActionPayload;
      data?: EmailEventRuleItem;
      request?: EmailEventRuleControllerUpdate$Params;
    }>(),
  ),
  updateSetState: createAction('email-event-rule/update/state', props<{ state: ILoaderActionPayload }>()),

  // delete
  deleteRule: createAction('email-event-rule/delete', props<EmailEventRuleControllerDelete$Params>()),
  deleteRuleDone: createAction(
    'email-event-rule/delete/done',
    props<{ state: ILoaderActionPayload; data?: EmailEventRuleItem }>(),
  ),
  deleteRuleSetState: createAction('email-event-rule/delete/state', props<{ state: ILoaderActionPayload }>()),
};
